import { z } from 'zod';
import { ID } from '../../utils/codecUtils';

export const deleteConnector = (connectorId: ID) => {
  return {
    endpoint: `/connectors/${connectorId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
